import EventTypes from './EventTypes';

export default EventTypes;
